/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsListboxComponent } from 'iriro-frontend-libs/bs-component-store';
@Component({
  selector: 'well-google-address-list',
  templateUrl: './google-address-list.component.html',
  styleUrls: ['./google-address-list.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, BsListboxComponent],
})
export class GoogleAddressListComponent {
  @Input() list: google.maps.places.AutocompletePrediction[] | undefined = undefined;

  @Input() error: string | undefined = undefined;

  selectedAddress: google.maps.places.AutocompletePrediction | undefined = undefined;

  @Output() selectPrediction = new EventEmitter<google.maps.places.AutocompletePrediction>();

  onSelect($event: google.maps.places.AutocompletePrediction) {
    this.selectPrediction.next($event);
  }
}
